import styled from '@emotion/styled';
import { Button, Card, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Percentage from 'ui-component/Percentage';
import Separator from 'ui-component/Separator';
import mintGif from 'assets/images/mint.gif';
import useContract from 'hooks/useContract';
import { ethers } from 'ethers';
import toast from 'utils/toast';
import { useWallet } from 'hooks/useWallet';

const Mint = () => {
  const { address } = useWallet();
  const contract = useContract();
  const [supply, setSupply] = useState(ethers.BigNumber.from(0));
  const [maxMint, setMaxMint] = useState(ethers.BigNumber.from(0));
  const [amount, setAmount] = useState(5);
  const [hasGiveaway, setHasGiveaway] = useState(0);

  const mint = async () => {
    await contract
      .mint(amount)
      .then((tx) => tx.wait())
      .catch((err) => {
        if (err.data && err.data.message) {
          toast.error(err.data.message);
        } else if (err.message) {
          if (err.message.includes('Not live')) toast.error('Minting not live yet');
          else toast.error(err.message);
        }

        console.log(err);
      });
  };

  const giveawayMint = async () => {
    await contract
      .mintGiveaway()
      .then((tx) => tx.wait())
      .then(() => toast.success('Mint complete'))
      .catch((err) => {
        if (err.message) {
          if (err.message.includes('Not live')) toast.error('Minting not live yet');
        }
        if (err.data && err.data.message) {
          toast.error(err.data.message);
        }

        console.log(err);
      });
  };

  useEffect(() => {
    console.log(contract);
    if (!contract) return;

    (async () => {
      const supply = await contract.totalSupply();
      const maxMint = await contract.maxMint();
      const giveaways = (await contract.giveawayAddresses(address)).toNumber();
      setHasGiveaway(giveaways);
      console.log(giveaways);

      setSupply(supply);
      setMaxMint(maxMint);
    })();
  }, [contract, address]);

  return (
    <StyledCard variant="outlined">
      <TopLeft>
        <div>
          <Typography variant="h1"> Minting </Typography>
          <Separator />
        </div>
        <Typography variant="h2" sx={{ width: '100%' }}>
          500 unique NFTs to mint for FREE ! <br />
          <br />
          Connect your wallet and chose the network you want to mint on. <br />
          <br />
          Clicking on the MINT button below will send you 2 free NFTs !
        </Typography>
        <div>
          <Percentage style={{ marginTop: '10px' }} percentage={(supply.toNumber() / maxMint.toNumber()) * 100} />
          <Typography sx={{ textAlign: 'center' }} variant="h3">
            Supply: {supply.toString()}/{maxMint.toString()}
          </Typography>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Input value={amount} id="outlined-number" label="Amount" type="number" onChange={(event) => setAmount(event.target.value)} />
          <MintButton onClick={mint} variant="contained">
            <Typography variant="h2">MINT</Typography>
          </MintButton>
        </div>
        {hasGiveaway > 0 && (
          <div>
            <Typography>You have {hasGiveaway} reserved mints from Giveaways</Typography>
            <MintButton variant="contained" onClick={giveawayMint}>
              Giveaway Mint
            </MintButton>
          </div>
        )}
      </TopLeft>
      <Gif src={mintGif} alt="mint gif" />
    </StyledCard>
  );
};

const Input = styled(TextField)`
  & > label {
    color: white;
  }
`;

const Gif = styled.img`
  border: 2px solid white;
  width: 40%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TopLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 550px;
  width: 40%;

  & > * {
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const MintButton = styled(Button)`
  width: 60%;
  height: 50px;
  align-self: center;
  background-color: #c20e02;
  border: 2px solid white;
`;

const StyledCard = styled(Card)`
  background-color: #131822;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  padding: 50px;
  margin: 20px;
  border: 2px solid white;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  width: 100%;
  min-height: 600px;

  @media (max-width: 425px) {
    padding: 20px;
  }
`;

export default Mint;
